export const CUENTA_USUARIO = "mediatecnicaapp@gmail.com"
export const CONTRASENA_USUARIO = "poli2020"
export const ID_USUARIO = Math.random().toString(36).substr(2, 9)
export const NOMBRE_CUENTA_USUARIO = "MediaTecnicApp"
export const NOMBRE_USUARIO = "Carlos"
export const APELLIDO_USUARIO = "Arboleda"